import {type FC} from "react"
import {Box, Stack} from "@mui/material"
import {CarouselItemProps} from "./types"
import carouselItemStyleDefault from "./styles"
import ThoughtPieceAuhtorDate from "../ThoughtPieceAuthorDate/ThoughtPieceAuthorDate"
import ResponsiveImage from "../../atoms/responsiveImage/ResponsiveImage"
import {Link} from "react-router-dom"
import useSelectedThoughtPiecesStore from "../../../stores/fullPageThoughtPiecesStore"
import EllipsisTypography from "../../atoms/customTypography/EllipsisTypography"
import {TruncatedTooltip} from "../../atoms/Tooltip"

const CarouselItem: FC<CarouselItemProps> = (props) => {
  const {
    articleId,
    index,
    title,
    imageLargePath,
    imageMediumPath,
    imageSmallPath,
    author,
    date,
    styles,
    itemUrl,
  } = props

  const {setId} = useSelectedThoughtPiecesStore()
  const carouselItemStyle = styles ? styles : carouselItemStyleDefault
  return (
    <Stack
      data-id={articleId}
      style={carouselItemStyle?.itemStyles}
      id={"carousel-item-" + index}
      spacing={1}
      direction={"column"}
    >
      <Box
        sx={{
          textDecoration: "none",
        }}
        component={Link}
        to={itemUrl}
        onClick={() => {
          setId(articleId)
        }}
      >
        <Box
          width={"100%"}
          sx={carouselItemStyle?.headerStyles?.boxStyle}
          justifyContent={"left"}
          marginBottom={"12px"}
        >
          <ThoughtPieceAuhtorDate
            author={author}
            date={date}
            separator="|"
            styles={carouselItemStyle?.headerStyles?.textStyle}
          />
        </Box>
        <Box width={"100%"} height={108}>
          <ResponsiveImage
            imageLargePath={imageLargePath}
            imageMediumPath={imageMediumPath}
            imageSmallPath={imageSmallPath}
            style={carouselItemStyle?.contentStyle?.imageStyle}
          />
        </Box>
        <Box
          width={"100%"}
          data-text-hover={true}
          sx={carouselItemStyle?.footerStyle?.textStyle}
          textAlign={"left"}
        >
          <EllipsisTypography
            text={title}
            lines={2}
            fontSize={14}
            tooltipComponent={TruncatedTooltip}
          ></EllipsisTypography>
        </Box>
      </Box>
    </Stack>
  )
}

export default CarouselItem
